import type HttpMethod from './HttpMethod';

export enum GraphQLErrorCode {
  GRAPHQL_PARSE_FAILED = 'GRAPHQL_PARSE_FAILED',
  GRAPHQL_VALIDATION_FAILED = 'GRAPHQL_VALIDATION_FAILED',
  BAD_USER_INPUT = 'BAD_USER_INPUT',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  FORBIDDEN = 'FORBIDDEN',
  PERSISTED_QUERY_NOT_FOUND = 'PERSISTED_QUERY_NOT_FOUND',
  PERSISTED_QUERY_NOT_SUPPORTED = 'PERSISTED_QUERY_NOT_SUPPORTED',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  NOT_FOUND = 'NOT_FOUND',
  CONFLICT = 'CONFLICT',
}

export interface IRequest {
  endpoint: string;
  method: HttpMethod;
  body?: string | Blob;
  headers?: Record<string, string>;
  responseType?: 'arraybuffer' | 'json';
  params?: Record<string, string | number | undefined | null>;
  externalBaseURL?: string;
  withCredentials?: boolean;
}

export interface IRequestResponse {
  statusCode: number;
  body: {};
}

export interface Configuration {
  host: string;
}

export interface GraphQLRestDataSourceError extends Error {
  url?: string;
  status?: number;
  statusText?: string;
  body?: string;
}
export interface EventSourceOptions {
  url: string;
}
